import { createTypes } from "../../utils/helpers";

const GET_SPECIAL_EVENT_REASONS: any = createTypes('GET_SPECIAL_EVENT_REASONS');
const SHOW_HOLIDAYS = 'SHOW_HOLIDAYS';
const SET_SELECTED_START_DATE = 'SET_SELECTED_START_DATE';
const SET_SELECTED_RANGE_DATE = 'SET_SELECTED_RANGE_DATE';
const SET_SPECIAL_EVENT_DATA = 'SET_SPECIAL_EVENT_DATA';
const SET_SPECIFIC_SPECIAL_EVENT_DATA = 'SET_SPECIFIC_SPECIAL_EVENT_DATA';
const SET_OPEN_24HOURS_TO_ALL = 'SET_OPEN_24HOURS_TO_ALL';
const SET_CLOSE_TO_ALL = 'SET_CLOSE_TO_ALL';
const CLEAR_FORM = 'CLEAR_FORM';
const CLEAR_TIMETABLE = 'CLEAR_TIMETABLE';
const SET_IS_LOADING: any = createTypes('SET_IS_LOADING');
const CREATE_SPECIAL_EVENT: any = createTypes('CREATE_SPECIAL_EVENT');
const GET_DELIVERY_HOURS: any = createTypes('GET_DELIVERY_HOURS');
const GET_MASS_UPLOAD_FILE: any = createTypes('GET_MASS_UPLOAD_FILE')

export {
    GET_SPECIAL_EVENT_REASONS,
    SHOW_HOLIDAYS,
    SET_SELECTED_START_DATE,
    SET_SELECTED_RANGE_DATE,
    SET_SPECIAL_EVENT_DATA,
    SET_SPECIFIC_SPECIAL_EVENT_DATA,
    SET_OPEN_24HOURS_TO_ALL,
    SET_CLOSE_TO_ALL,
    CREATE_SPECIAL_EVENT,
    CLEAR_FORM,
    CLEAR_TIMETABLE,
    SET_IS_LOADING,
    GET_DELIVERY_HOURS,
    GET_MASS_UPLOAD_FILE
}
